module.exports = __webpack_public_path__ + "img/山楂.c32416b8.png";